import React from "react";
import {useState} from "react";
import {MDBFormInline, MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBCard, MDBCardBody, MDBCardTitle } from 'mdbreact';
import DatePicker from "react-datepicker";
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";

import "react-datepicker/dist/react-datepicker.css";



class FormPage extends React.Component {
    
    

    constructor(props) {
        super(props);
        this.state = { name: '', phone: '', email: '',
        startDate: new Date(), msg: '', notARobot: false 
         }; 
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    

    onChange() { 
        return this.setState({ notARobot: !this.state.notARobot}) 
    };

    handleFormSubmit(event) {
        event.preventDefault();
        if (this.state.notARobot == true) {
        axios.post("http://207.246.115.162:8080/api", this.state)
        .then(alert("Thank you for booking an appointment with us " + this.state.name + "! We will call you to confirm."))
        .then(this.setState({
            name: '', phone: '', email: '',
            startDate: new Date(), msg: ''
        }))
        .catch(function (error) {
            if (error.response) {
                alert("There was an error, please call us at 702-782-6162 to book your appointment.");
        }

        
    

    });
} else {
    alert("Please confirm you are human");
}


}

    

    handleChange(event) {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({ [nam]: val }); 

    }

    handleDate = date => {
        this.setState({
            startDate: date
        });
    };
    
    

    render() {
    
        
        
    return (

        
       
       
        <MDBRow>
            <MDBCol>
            <MDBCard className="box userinput" style={{}}>
                <MDBCardBody style={{overflow: "hidden"}} className="mx-4 mt-5">
                    <form onSubmit={this.handleFormSubmit} className="formstyle">
                        <MDBCardTitle>
                        <p className="h3 text-center mb-5">Schedule An Interview:</p></MDBCardTitle>
                        
                            <MDBInput
                                label="Name"
                                name="name"
                                onChange={this.handleChange}
                                icon="user"
                                group
                                required
                                type="text"
                                validate
                                error="wrong"
                                success="right"
                                value={this.state.name}
                            />
                            <DatePicker
                                selected={this.state.startDate}
                                minDate={new Date()}
                                dateFormat="MM/dd/yyyy"
                                onChange={this.handleDate}
                                value={this.state.startDate}
                            />
                            <div className="date">Appointment Date</div>
                            <MDBInput
                                label="Phone Number"
                                onChange={this.handleChange}
                                required
                                icon="user"
                                name="phone"
                                group
                                type="number"
                                validate
                                error="wrong"
                                success="right"
                                value={this.state.phone}
                            />
                            <MDBInput
                                label="Email Address"
                                icon="envelope"
                                required
                                name="email"
                                onChange={this.handleChange}
                                group
                                type="email"
                                validate
                                error="wrong"
                                success="right"
                                value={this.state.email}
                            />
                            
                            
                            <MDBInput
                                name='msg'
                                type="textarea"
                                onChange={this.handleChange}
                                rows="2"
                                label="Your message"
                                icon="pencil-alt"
                                value={this.state.msg}
                            />
                            
                            <ReCAPTCHA
                                sitekey="6LezEN4UAAAAAIlD3OPOyR0xEGNA0tItHGt0RShx"
                                onChange={this.onChange}
                                theme="dark"
                                size="normal"
                            />
                        
                            <div className="text-center py-4 mt-3">
                                <MDBBtn style={{ border: "1px solid transparent", color: "white"}} type="submit">
                                    Submit
                  </MDBBtn>
                            </div>
                            
                    </form>
                    </MDBCardBody>
        </MDBCard>
                
            </MDBCol>
        </MDBRow>        
        
    );
};
}

export default FormPage;